import styled from '@emotion/styled'
import { WebLink } from '@news-mono/web-common'
import { breakpoint } from '../../../__styling/style-functions/breakpoint'
import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { transition } from '../../../__styling/style-mixins'

interface OlympicWidgetStyleProps {
    isFullSize: boolean
}

export const StyledFlexRow = styled('section')<OlympicWidgetStyleProps>(
    ({ theme, isFullSize }) => ({
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        width: '100%',
        justifyContent: isFullSize ? 'flex-end' : 'flex-start',
        [breakpoint('sm')]: {
            width: 'unset',
        },
    }),
)

export const StyledWebLink = styled(WebLink)(({ theme }) => ({
    backgroundColor: theme.colors.actions.button.primary.background.default,
    color: theme.colors.actions.button.primary.text.default,
    alignItems: 'center',
    border: '1px solid',
    textDecoration: 'none',
    padding: calcRem(8, 7),
    width: '100%',
    fontSize: calcRem(13),
    fontWeight: 700,
    borderRadius: '3px',
    textAlign: 'center',
    ...transition({ properties: ['background-color', 'color'] }),
    [breakpoint('sm')]: {
        width: calcRem(91),
    },
    '&:not(:first-child)': {
        marginLeft: calcRem(10),
    },

    '&:hover': {
        backgroundColor: theme.colors.actions.button.primary.background.hover,
        color: theme.colors.actions.button.primary.text.hover,
    },

    '&:focus': {
        backgroundColor: theme.colors.actions.button.primary.background.hover,
        color: theme.colors.actions.button.primary.text.hover,
    },

    '&.isActive': {
        backgroundColor: theme.colors.actions.button.primary.background.active,
        color: theme.colors.actions.button.primary.text.active,

        '&:hover': {
            backgroundColor:
                theme.colors.actions.button.primary.background.hover,
            color: theme.colors.actions.button.primary.text.hover,
        },

        '&:focus': {
            backgroundColor:
                theme.colors.actions.button.primary.background.hover,
            color: theme.colors.actions.button.primary.text.hover,
        },
    },
}))
